$( document ).ready(function() {
    $('#donor-date_of_birth-picker').datetimepicker({
        viewMode: 'years',
        viewDate: moment().subtract(20, 'years'),
        maxDate: moment(),
        useCurrent: false,
        format: 'MM/DD/YYYY'
    });
});
